import { useCallback, useEffect, useState } from 'react';

const baseUrlFallback = process.env.REACT_APP_BASE_URL || '';

export function useNotificationUnreadCount(baseUrl = baseUrlFallback) {
  const [unreadCount, setUnreadCount] = useState(0);

  const refreshUnreadCount = useCallback(async () => {
    try {
      const res = await fetch(`${baseUrl}/api/notifications/unread-count`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });
      const data = await res.json().catch(() => ({}));
      if (data?.success) setUnreadCount(Number(data.count) || 0);
    } catch {
      /* ignore */
    }
  }, [baseUrl]);

  useEffect(() => {
    refreshUnreadCount();
  }, [refreshUnreadCount]);

  useEffect(() => {
    const onFocus = () => refreshUnreadCount();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, [refreshUnreadCount]);

  return { unreadCount, hasUnread: unreadCount > 0, refreshUnreadCount };
}
